<template>
  <Modal
    id="consultation-modal"
    :value="isShow"
    :scrollable="true"
    :mask-closable="false"
    :title="''"
    @on-visible-change="change"
    width="640">
    <div class="content" :style="{backgroundImage: `url(${require('../../assets/' + assetsConfig.homePage.footer.formBg)})`, backgroundRepeat: `no-repeat`, backgroundPosition: `bottom`}">
      <h4>获取方案与报价方案</h4>
      <p class="sub-title">填写以下信息，我们将在两个工作日内联系并提供咨询服务</p>
      <Form ref="Form" :label-width="250" :model="postForm" v-if="isShow">
        <Row>
          <Col span="24">
            <FormItem label="您的称呼" prop="user_name" :rules="postRules.user_name">
              <Input v-model="postForm.user_name" placeholder="称呼（必填）" style="width: 180px;"/>
            </FormItem>
            <FormItem label="手机号码" prop="phone" :rules="postRules.phone">
              <Input v-model="postForm.phone" placeholder="手机号码（必填）" style="width: 180px;"/>
            </FormItem>
            <FormItem label="公司名称" prop="company" :rules="postRules.company">
              <Input v-model="postForm.company" placeholder="公司名称（必填）" style="width: 180px;"/>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="电子邮箱" prop="email" :rules="postRules.email">
              <Input v-model="postForm.email" placeholder="邮箱（用于接收资料）" style="width: 180px;"/>
            </FormItem>
            <FormItem label="联系时间" prop="expect_time" :rules="postRules.expect_time" v-if="!isIE">
              <Select v-model="postForm.expect_time" ref="select" style="width: 180px;" placeholder="选择联系时间（必填）">
                <Option v-for="i in timeList" :key="i.value" :value="i.value">{{i.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="联系时间" prop="expect_time" v-else class="required">
              <div>
                <div class="radio-group">
                  <input type="radio" name="time" value="workday" @click="choseExpectTime('workday')">工作时间</input>
                  <input type="radio" name="time" value="offday" @click="choseExpectTime('offday')">非工作时间</input>
                </div>
                <div class="error" v-if="errorMsg">{{errorMsg}}</div>
              </div>
            </FormItem>
            <FormItem label="关注行业" prop="industry_focus" :rules="postRules.industry_focus" v-if="!isIE">
              <Select v-model="postForm.industry_focus" ref="select" style="width: 180px;" placeholder="关注行业（必填）">
                <Option v-for="i in industryList" :key="i.value" :value="i.name">{{i.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="关注行业" prop="industry_focus" v-else class="required">
              <div>
                <div class="radio-group">
                  <input type="radio" name="industry_focus" value="电力行业" @click="choseExpectFocus('电力行业')">电力行业</input>
                  <input type="radio" name="industry_focus" value="教育行业" @click="choseExpectFocus('教育行业')">教育行业</input>
                  <input type="radio" name="industry_focus" value="能源行业" @click="choseExpectFocus('能源行业')">能源行业</input>
                  <input type="radio" name="industry_focus" value="交通行业" @click="choseExpectFocus('交通行业')">交通行业</input>
                  <input type="radio" name="industry_focus" value="制造行业" @click="choseExpectFocus('制造行业')">制造行业</input>
                  <input type="radio" name="industry_focus" value="音视频分析" @click="choseExpectFocus('音视频分析')">音视频分析</input>
                  <!-- <input type="radio" name="industry_focus" :value="i.name" @click="choseExpectFocus(i.name)" v-for="i in industryList" :key="i.value">{{i.name}}</input> -->
                </div>
                <div class="error" v-if="focusErrorMsg">{{errorMsg}}</div>
              </div>
            </FormItem>
          </Col>
        </Row>
        <p class="explain">
          点击提交视为您已阅读并同意江苏泰坦智慧
          <router-link :to="privacyUrl" target="_blank">《隐私政策》</router-link>
        </p>
        <FormItem :label-width="0" class="btn-form">
          <Button @click="submitForm" class="lg-btn" type="primary">提交</Button>
        </FormItem>
      </Form>
    </div>
    <span slot="close">
      <i class="ivu-icon ivu-icon-ios-close" @click="cancel"></i>
    </span>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
export default {
  name: 'consultation-modal',
  props: ['isShow'],
  watch: {
    isShow: {
      handler(val, oldVal) {
        if (val === true) {
          // 清空并显示弹窗
          if (this.isIE) {
            this.postForm.expect_time = ''
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      postForm: {},
      postRules: {
        user_name: [
          { required: true, message: '称呼不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, type: 'string', trigger: 'blur', validator: this.UTILS.phoneValidate }
        ],
        expect_time: [
          { required: true, message: '请选择联系时间', trigger: 'change' }
        ],
        company: [
          { required: true, message: '公司名称为必填', trigger: 'blur' }
        ],
        email: [
          {
            required: true, message: '邮箱为必填', trigger: 'blur'
          }, {
            pattern: this.UTILS.emailPattern(), message: '邮箱格式不正确', trigger: 'blur'
          }
        ],
        industry_focus: [
          { required: true, message: '请选择关注行业', trigger: 'change' }
        ]
      },
      timeList: [{ name: '工作时间', value: 'workday' }, { name: '非工作时间', value: 'offday' }],
      industryList: [
        {
          name: '电力行业',
          value: 'power'
        }, {
          name: '教育行业',
          value: 'teach'
        },  {
          name: '能源行业',
          value: 'energy'
        }, {
          name: '交通行业',
          value: 'traffic'
        }, {
          name: '制造行业',
          value: 'port'
        }, {
          name: '音视频分析',
          value: 'video'
        }
      ],
      privacyUrl: '',
      isIE: false,
      errorMsg: '',
      focusErrorMsg: '',
      assetsConfig: ASSETS_CONFIG
    }
  },
  mounted() {
    this.privacyUrl = '/privacy'
    let browser = navigator.appName
    let b_version = navigator.appVersion
    let version = b_version.split(';')
    let trim_version = version.length > 1 ? version[1].replace(/[ ]/g, '') : ''
    let float_version = parseFloat(trim_version.toUpperCase().replace('MSIE', ''))
    if (browser === 'Microsoft Internet Explorer' && float_version <= 10) {
      this.isIE = true
    }
  },
  methods: {
    cancel() {
      this.$emit('on-cancel')
      this.clear()
    },
    change($event) {
      if ($event == false) {
        this.$emit('on-cancel')
        this.clear()
      }
    },
    clear() {
      this.$refs['Form'].resetFields()
      this.errorMsg = ''
      this.focusErrorMsg = ''
    },
    choseExpectTime(e) {
      this.postForm.expect_time = e
      if (!this.postForm.expect_time) {
        this.errorMsg = '请选择联系时间'
      } else {
        this.errorMsg = ''
      }
    },
    choseExpectFocus(e) {
      this.postForm.industry_focus = e
      if (!this.postForm.industry_focus) {
        this.focusErrorMsg = '请选择关注行业'
      } else {
        this.focusErrorMsg = ''
      }
    },
    submitForm() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          if (!this.postForm.expect_time) {
            this.errorMsg = '请选择联系时间'
            return false
          } else {
            this.errorMsg = ''
          }
          if (!this.postForm.industry_focus) {
            this.focusErrorMsg = '请选择关注行业'
            return false
          } else {
            this.focusErrorMsg = ''
          }
          this.$axios
            .post(`/whileflow/v1/customers`, this.postForm)
            .then((res) => {
              if (res && res.data) {
                this.$Message.success('您已成功提交信息，我们将在两个工作日内与您联系。')
                this.cancel()
              } else {
                this.$Message.error('提交失败，请稍后再试...')
              }
            })
            .catch((err) => {
              this.$Message.error('提交失败，请稍后再试...')
              console.log(err)
            })
        } else {
          if (!this.postForm.expect_time) {
            this.errorMsg = '请选择联系时间'
          } else {
            this.errorMsg = ''
          }
          if (!this.postForm.industry_focus) {
            this.focusErrorMsg = '请选择关注行业'
          } else {
            this.focusErrorMsg = ''
          }
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
#consultation-modal
  .radio-group
    text-align left
  .error
    text-align left
    color #ed4014
  .ivu-modal-content
    .ivu-modal-footer
      padding 0
      border none

    .ivu-form-item-content
      text-align left
    .btn-form .ivu-form-item-content
        text-align center

    .ivu-form-item
      margin-bottom 8px

    .ivu-form-item-error-tip
      position absolute
      top 12.5%
      left 50%
    .required label::before
      content '*'
      display inline-block
      margin-right 4px
      line-height 1
      font-family SimSun
      font-size 12px
      color #ed4014
    .ivu-modal-body
      padding 0
      .content
        height 500px
        padding 35px 0px
        text-align center
        overflow auto
      h4
        margin-bottom 10px
        font-size 18px

      .sub-title
        margin-bottom 25px
        position relative

      .ivu-input, .ivu-select-selection
        border-width 0 0 1px 0
        border-radius 0

      .ivu-select-selection, .ivu-select-dropdown-list
        text-align left

      .explain
        margin 30px 0 10px

      .lg-btn
        width 360px

      input, input:hover, input:focus, .ivu-select-visible .ivu-select-selection, .ivu-input:focus
        box-shadow none
        outline none
</style>



// WEBPACK FOOTER //
// src/components/basic/ConsultationModal.vue